import { defineComponent as _defineComponent } from 'vue'
import { computed, type PropType } from 'vue'
import { AccountMembershipRole } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MembershipRoleSelect',
  props: {
  value: {
    type: [String, Array] as PropType<
      AccountMembershipRole | AccountMembershipRole[]
    >,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  disableReviewer: {
    type: Boolean,
    default: false,
  },
  showAdmin: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const menuProps = computed(() => ({
  contentClass: 'membership-role-select-menu',
  maxHeight: 120,
  offsetY: true,
}))

const onDisabledItemClick = (
  item: { disabled?: boolean },
  event: MouseEvent,
) => {
  if (item.disabled) {
    event.preventDefault()
    event.stopPropagation()
  }
}

/** Empty `label` — chip is the only visible selection; avoids duplicate text row under the chip */
const roleOptions = computed(() => [
  ...(props.showAdmin
    ? [
        {
          value: 'ADMIN' as AccountMembershipRole,
          label: '',
          disabled: false,
        },
      ]
    : []),
  { value: AccountMembershipRole.Editor, label: '', disabled: false },
  {
    value: AccountMembershipRole.Reviewer,
    label: '',
    disabled: props.disableReviewer,
  },
])

return { __sfc: true,props, menuProps, onDisabledItemClick, roleOptions }
}

})